module.exports = __webpack_public_path__ + "img/background034.jpg";